// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__Htyk9","banner":"Home_banner__RQ-oU","main":"Home_main__opUg+","bookList":"Home_bookList__-eKjz"};